exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js?{\"minimize\":true,\"sourceMap\":true}!../assets/themify.css"), "");

// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"_BlockSettingsElements.vue","sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-fbf18422","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/blocks/_BlockSettingsElements.vue
// module id = 465
// module chunks = 0 1 2 3 4